// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-container {
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    width: "%90";
    position: relative;
    padding-bottom: 76px;
  }
  
  .ant-collapse-ghost > .ant-collapse-item {
    border-bottom: 1px solid #f0f0f0 !important;
  }
  
  .ant-collapse-ghost > .ant-collapse-item:last-child {
    border-bottom: none !important;
  }
  
  .ant-collapse-header {
    padding: 12px 0 !important;
    font-weight: 500 !important;
    color: #333 !important;
  }
  
  .ant-collapse-content-box {
    padding: 0 0 12px 0 !important;
  }
  
  .select-input {
    width: 100%;
    margin-bottom: 8px;
  }
  
  .checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .radio-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .sector-search {
    margin-bottom: 12px;
  }
  
  .button-wrapper {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    padding: 16px 20px;
    margin: 0 -20px -20px -20px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    box-shadow: 0 -4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  
  .apply-button {
    width: 100%;
    height: 40px;
    background: #001aec;
    border: none;
  }
  
  .apply-button:hover {
    background: #293ee4 !important;
  }`, "",{"version":3,"sources":["webpack://./src/pages/Personnel/Filter/Filter.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;IAC3B,8BAA8B;IAC9B,+BAA+B;IAC/B,+CAA+C;EACjD;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,8BAA8B;EAChC","sourcesContent":[".filter-container {\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    width: \"%90\";\n    position: relative;\n    padding-bottom: 76px;\n  }\n  \n  .ant-collapse-ghost > .ant-collapse-item {\n    border-bottom: 1px solid #f0f0f0 !important;\n  }\n  \n  .ant-collapse-ghost > .ant-collapse-item:last-child {\n    border-bottom: none !important;\n  }\n  \n  .ant-collapse-header {\n    padding: 12px 0 !important;\n    font-weight: 500 !important;\n    color: #333 !important;\n  }\n  \n  .ant-collapse-content-box {\n    padding: 0 0 12px 0 !important;\n  }\n  \n  .select-input {\n    width: 100%;\n    margin-bottom: 8px;\n  }\n  \n  .checkbox-group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .radio-group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .sector-search {\n    margin-bottom: 12px;\n  }\n  \n  .button-wrapper {\n    position: sticky;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: white;\n    padding: 16px 20px;\n    margin: 0 -20px -20px -20px;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n    box-shadow: 0 -4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  \n  .apply-button {\n    width: 100%;\n    height: 40px;\n    background: #001aec;\n    border: none;\n  }\n  \n  .apply-button:hover {\n    background: #293ee4 !important;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
